.react-calendar {
  font-family: 'Karla_400Regular';
  font-size: 20;
}
